import { Statistic } from '../../../workers/sortAndFilter/statistics/statistics.worker';
import { Command, TreatmentForm } from '../interfaces';
import { FilterCommand } from './FilterCommand';

/**
 * Filter based on medical form.
 * @param data a treatment
 * @returns Statistic
 */
export const treatmentFormFilterStatistics = <T extends TreatmentForm>(data: T[], keys: string[]) =>
    data.filter((element) => element.treatmentForm.some((element) => keys.includes(element.title)));

export class TreatmentFormFilterStatisticsCommand extends FilterCommand implements Command {
    isAndFilter() {
        return undefined;
    }

    execute(data: TreatmentForm[], keys: string[]) {
        let items = null;
        const statistics: Statistic[] = [];
        keys.forEach((value) => {
            items = treatmentFormFilterStatistics(data, [value]);
            const statistic = {
                type: this.type,
                key: value,
                statistics: {
                    value: items.length,
                },
            };
            statistics.push(statistic);
        });
        return statistics;
    }
}
